var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQueryClient, } from "@tanstack/react-query";
import { useCreditHealthMutation, useCreditHealthQuery, } from "@syf-api-library/credit-health";
import { useCreditAccountsQuery, } from "@syf-api-library/credit-accounts";
import { useAccountSummaryV2Query as useAccountSummaryQuery, useAllAccountSummaryQuery, } from "@syf-api-library/account-summary";
import getApiConfig from "../helpers/getApiConfig";
import { useConfig } from "../hooks/useConfig";
var useCreditAccounts = function (queryOptions) {
    var config = useConfig();
    var queryClient = useQueryClient();
    var enabledQuery = Boolean(sessionStorage.getItem("accessToken"));
    var apiConfig = getApiConfig(queryClient, config, enabledQuery, queryOptions);
    return useCreditAccountsQuery(__assign({}, apiConfig));
};
var useAccountSummary = function (accountId) {
    var config = useConfig();
    var queryClient = useQueryClient();
    var enabledQuery = Boolean(accountId);
    var apiConfig = getApiConfig(queryClient, config, enabledQuery);
    return useAccountSummaryQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useAllAccountSummary = function (accounts) {
    var config = useConfig();
    var queryClient = useQueryClient();
    var enabledQuery = Boolean(accounts.length);
    var keyProps = accounts.map(function (account) {
        var _a;
        return {
            accountId: account.info["cipher.accountId"],
            accountIdType: (_a = account === null || account === void 0 ? void 0 : account.info) === null || _a === void 0 ? void 0 : _a.accountIdType,
        };
    });
    var apiConfig = getApiConfig(queryClient, config, enabledQuery);
    return useAllAccountSummaryQuery(__assign({ keyProps: keyProps }, apiConfig));
};
var useGetVantageCreditScore = function (accountId) {
    var config = useConfig();
    var queryClient = useQueryClient();
    var enabledQuery = Boolean(accountId);
    var apiConfig = getApiConfig(queryClient, config, enabledQuery);
    return useCreditHealthQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid", lang: config.lang } }, apiConfig));
};
export var CREDIT_HEALTH_QUERY_KEY = "v1/credit/accounts/credit-health";
var useCreditHealthPutMutation = function (_a) {
    var config = _a.config;
    var queryClient = useQueryClient();
    var enabledMutation = Boolean(sessionStorage.getItem("accessToken"));
    var apiConfig = getApiConfig(queryClient, config, enabledMutation);
    return useCreditHealthMutation(__assign(__assign({}, apiConfig), { keyProps: null }));
};
export { useAccountSummary, useAllAccountSummary, useCreditAccounts, useCreditHealthPutMutation, useGetVantageCreditScore, };
